export const A4_OPTS = [
  {
    empty: true,
  },
  {
    col: 1,
    row: 1,
    width: 340,
    fontSize: 22,
    secFontSize: 21,
  },
  {
    col: 1,
    row: 2,
    width: 220,
    textWidth: 270,
    textLeft: 24,
    fontSize: 20,
    secFontSize: 18,
  },
  {
    col: 2,
    row: 2,
    width: 150,
    textWidth: 200,
    textLeft: 12,
    fontSize: 15,
    secFontSize: 15,
  },
  {
    col: 2,
    row: 5,
    width: 100,
    textWidth: 145,
    textLeft: 6,
    fontSize: 10,
    secFontSize: 10,
  },
  {
    col: 3,
    row: 6,
    topLines: 2,
    width: 68,
    textWidth: 86,
    textLeft: 6,
    fontSize: 10,
    secFontSize: 10,
  },
];

export const QRPRINT_OPTS = [
  {
    padding: 10,
    width: 92,
    fontSize: 12,
  },
  {
    padding: 10,
    width: 106,
    fontSize: 12,
  },
  {
    padding: 15,
    width: 105,
    topLines: 2,
    textWidth: 125,
    textLeft: 12,
    fontSize: 16,
    secFontSize: 16,
  },
  {
    padding: 18,
    width: 122,
    topLines: 3,
    textWidth: 140,
    textLeft: 14,
    fontSize: 16,
    secFontSize: 16,
  },
  {
    padding: 28,
    width: 180,
    topLines: 3,
    textWidth: 180,
    textLeft: 18,
    fontSize: 20,
    secFontSize: 20,
  },
];

export const A4_SIZE = {
  mm: {
    width: 210,
    height: 297,
  },
  px: {
    width: 630,
    height: 891,
  },
};

export const QRPRINT_SIZES = [
  {
    mm: {
      width: 20,
      height: 30,
    },
    px: {
      width: 112,
      height: 168,
    },
  },
  {
    mm: {
      width: 30,
      height: 40,
    },
    px: {
      width: 126,
      height: 168,
    },
  },
  {
    mm: {
      width: 60,
      height: 40,
    },
    px: {
      width: 270,
      height: 180,
    },
  },
  {
    mm: {
      width: 80,
      height: 60,
    },
    px: {
      width: 296,
      height: 220,
    },
  },
  {
    mm: {
      width: 100,
      height: 80,
    },
    px: {
      width: 420,
      height: 336,
    },
  },
];
